import React from "react";
import { useNavigate } from "react-router-dom";

const Footer = () => {
  const navigate = useNavigate();

  return (
    <footer
      style={{ background: "#ECF6FF", zIndex: 1000 }}
      className="w-full bg-white rounded-lg shadow-lg dark:bg-gray-800 fixed bottom-0"
    >
      <div
        className="max-w-screen-xl mx-auto p-4 flex sm:justify-between md:justify-center relative"
        style={{ margin: "-7px" }}
      >
        {/* Centered Copyright Text */}
        <span className="text-12 text-gray-500 text-center dark:text-gray-700">
          © {new Date().getFullYear()}{" "}
          <a className="hover:underline" style={{ cursor: 'pointer' }}>
            Techno Land Engineers And Surveyors
          </a>
          . All Rights Reserved.
        </span>

        {/* Right-Aligned Support Link */}
        {/* <span className="absolute right-4 text-12 text-gray-500 dark:text-gray-700">
          <a
            className="hover:underline cursor-pointer"
            onClick={() => navigate("/support")}
          >
            For Support
          </a>
        </span> */}
      </div>
    </footer>
  );
};

export default Footer;
